// @ts-nocheck
import { Typography } from "@mui/material";
import { getCssVariableHandler } from "../../utils/styles/getCssVariables";
import { useMemo } from "react";
import { CONTRACTOR_TYPE_3RD_PARTY } from "../../utils/constants/nmaes";
import PropTypes from "prop-types";

export const ThirdPartyTag = ({ contractorType }) => {
  const isThirdParty = useMemo(() => {
    return (
      contractorType == CONTRACTOR_TYPE_3RD_PARTY.OUTSOURCED ||
      contractorType == CONTRACTOR_TYPE_3RD_PARTY.THIRD_PARTY
    );
  }, [contractorType]);

  if (!isThirdParty) return null;

  return (
    <Typography
      component={"span"}
      sx={{
        fontSize: "0.8rem",
        ml: "0.15rem",
        fontWeight: "500",
        display: "inline-flex",
        padding: "0rem 0.25rem",
        borderRadius: "0.25rem",
        textDecoration: "capitalize",
        background: getCssVariableHandler({ variableName: "--white-rgb" }),
        color: getCssVariableHandler({
          variableName: "--black-shade-2-rgb",
        }),
      }}
    >
      {contractorType == "thirdParty" ? "T" : "O"}
    </Typography>
  );
};

ThirdPartyTag.propTypes = {
  contractorType: PropTypes.string,
};